module.exports = __webpack_public_path__ + "static/media/slide-1.17fb0959.jpg";